import { useEffect, FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import styled from 'styled-components';
import config from '../config';

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
  text-align: center;
  width: 100%;
`;

export const AuthCallback: FC = () => {
  const { setAuthToken, verifyCSRF } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const handleAuthCode = async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get('code');
      const state = params.get('state');

      if (!verifyCSRF(state) || !code) {
        console.error('CSRF token mismatch or missing code');
        navigate('/');
        return;
      }

      try {
        const response = await fetch(`${config.cognitoUrl}/oauth2/token`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: new URLSearchParams({
            grant_type: 'authorization_code',
            client_id: config.userPoolWebClientId,
            code,
            redirect_uri: window.location.origin + '/callback',
          }),
        });

        const data = await response.json();
        setAuthToken(data.id_token);
        
        const secretId = sessionStorage.getItem('secretId');
        navigate(secretId ? `/secrets/${secretId}` : '/');
      } catch (error) {
        console.error('Auth error:', error);
        navigate('/');
      }
    };

    handleAuthCode();
  });

  return <Container>Authenticating...</Container>;
};
